import { storageHelper } from '@core-ui/utility';
import { SCROLLED_CID, SCROLL_Y_POSITION } from '../../utils/constants';

export const storeScrollPosition = (
  event: React.MouseEvent<HTMLDivElement>,
  pcid: string
) => {
  const { setItem } = storageHelper(sessionStorage);

  setItem(SCROLLED_CID, pcid);
  setItem(SCROLL_Y_POSITION, window.pageYOffset.toString());
};
